export enum AppStatusesE {
    DEFAULT = 'default',
    SUCCESS = 'success',
    FAILURE = 'fail',
    PENDING = 'pending'
}
